import React from 'react';
import './deleteModal.css'

const DeleteModal = ({showModal=false,setShowModal,title='Title',titleIconClass='',children,onClose}) => {

    const closeModal = () => {
        try{
            onClose()
            setShowModal(false)
        }catch{
            setShowModal(false)
        }
    }

    if(showModal){
        return(
            <>
                <div className='custom-modal-overlay-delete' onClick={closeModal}>
                </div>
                <div className="custom-modal-delete custom-bg-light">
                    <header>
                        <canvas className={'icon ms-3 me-2 '+titleIconClass}></canvas>
                        <span>{title}</span>
                        <canvas onClick={closeModal} className='icon white-close-icon me-3 ms-auto'></canvas>
                    </header>
                    <body className='custom-bg-light body'>
                        {
                            children
                        }
                    </body>
                </div>
            </>
        )
    }
};

export default DeleteModal;